import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PauseMouseIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M21.7 22.02a1 1 0 0 1-1.4 0l-.94-.93a.86.86 0 0 0-1.42.31.86.86 0 0 1-1.64-.04l-1.73-5.54a1 1 0 0 1 1.25-1.25l5.54 1.73a.86.86 0 0 1 .04 1.64.86.86 0 0 0-.3 1.42l.92.93a1 1 0 0 1 0 1.42l-.31.31Zm-15-5.58a.6.6 0 0 1-.16.42.8.8 0 0 1-.48.14H3.63a.63.63 0 0 1-.43-.14.54.54 0 0 1-.2-.42V6.56c0-.17.07-.3.2-.39.1-.11.25-.17.43-.17h2.43a.7.7 0 0 1 .48.17c.1.1.16.22.16.39v9.88Zm6.3 0a.6.6 0 0 1-.16.42.8.8 0 0 1-.47.14H9.94a.63.63 0 0 1-.44-.14.54.54 0 0 1-.2-.42V6.56c0-.17.07-.3.2-.39.1-.11.25-.17.44-.17h2.43a.7.7 0 0 1 .47.17c.1.1.16.22.16.39v9.88Z" />
    </SvgIcon>
);
